import { Modal, Form, Select, Typography, Grid } from "antd";
import { useEffect } from "react";

import { REVIEW_ACTION_CONFIG } from "../../helper";

const { Text } = Typography;

const REVIEW_ACTION_OPTIONS = Object.entries(REVIEW_ACTION_CONFIG).map(([action, { label }]) => ({
  label,
  value: action
}));

/**
 * Review form for one reconciliation-queue row: reject it as invalid, mark it
 * unavailable, or reopen it as unresolved work. The decision is the whole
 * record; the row's status is what the next admin who opens the same link
 * reads.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {(action: string) => void} props.onSubmit
 * @param {boolean} props.isSubmitting
 */
const ReviewModal = ({ open, onClose, onSubmit, isSubmitting }) => {
  const [form] = Form.useForm();
  const screens = Grid.useBreakpoint();
  const selectedAction = Form.useWatch("action", form);
  const isMobileView = screens.md === false;

  /**
   * Passes the chosen decision up to the parent.
   *
   * @param {{action: string}} formValues
   */
  const handleFinish = ({ action }) => onSubmit(action);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  return (
    <Modal
      title="Review Request"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={isSubmitting}
      okText="Apply"
      width={isMobileView ? "94%" : undefined}
      styles={{ content: { backgroundColor: "var(--component-bg)" } }}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="Decision"
          name="action"
          rules={[{ required: true, message: "Pick a decision" }]}
        >
          <Select options={REVIEW_ACTION_OPTIONS} placeholder="Select a decision" />
        </Form.Item>

        {selectedAction && (
          <Text type="secondary" style={{ display: "block" }}>
            {REVIEW_ACTION_CONFIG[selectedAction].helpText}
          </Text>
        )}
      </Form>
    </Modal>
  );
};

export default ReviewModal;
